<div style="background: #FBFBFB; margin: -45px calc(-5% - 10px) 0 calc(-5% - 10px);">
  <div style="padding: 0 5% 0 5%; padding-bottom: 0;">
    <div fxLayout="column" class="project-content" (click)="retornarHome()" style="cursor: pointer;">
      <div fxLayout="row" fxLayoutGap="10px" style="margin-top: 45px;">
        <span class="btn-voltar-catalogo" fxLayoutAlign="start center">
          <span class="material-icons">
            keyboard_arrow_left
          </span>
          Voltar
        </span>
      </div>
    </div>
    <div id="content-saiba-mais">
      @if (conteudo?.tipo) {
        <p id="tipo-conteudo">{{conteudo?.tipo}}</p>
      }
      @if (conteudo?.descricao) {
        <p id="nome-conteudo">{{conteudo?.descricao}}</p>
      }
      @if (conteudo.dscPublicado) {
        <div id="descricao-conteudo" [innerHTML]="conteudoHTML"></div>
      }
    </div>
  </div>
  <div style="background: #FFFFFF;">
    <div id="container-carousel" style="padding: 5%">
      <p id="label-leia-tambem">Leia também</p>
      <div class="item-carousel-line">
        <div class="arrow-button" (click)="owlCar.prev()">
          <span class="material-icons">
            keyboard_arrow_left
          </span>
        </div>
      </div>
      <div style="width: calc(100% - 160px);" class="item-carousel-line">
        <owl-carousel-o [options]="customOptions" #owlCar>
          @for (item of outrosItens; track item) {
            <ng-template carouselSlide [id]="item.id">
              @if (isVertente()) {
                <div>
                  <div class="item-carousel">
                    <app-card-vertente-info-public [vertente]="item"></app-card-vertente-info-public>
                  </div>
                </div>
              }
              @if (isTiming()) {
                <div>
                  <div class="item-carousel">
                    <app-card-timing-info-public [timing]="item"></app-card-timing-info-public>
                  </div>
                </div>
              }
              @if (isPassoImplantacao()) {
                <div>
                  <div class="item-carousel">
                    <app-card-passos-implementacao [passo]="item"></app-card-passos-implementacao>
                  </div>
                </div>
              }
            </ng-template>
          }
        </owl-carousel-o>
      </div>
      <div class="item-carousel-line">
        <div class="arrow-button" (click)="owlCar.next()">
          <span class="material-icons">
            keyboard_arrow_right
          </span>
        </div>
      </div>
    </div>
  </div>
</div>